import { render } from "./CognitoBrandedShell.vue?vue&type=template&id=497ccc92&scoped=true&ts=true"
import script from "./CognitoBrandedShell.vue?vue&type=script&lang=ts"
export * from "./CognitoBrandedShell.vue?vue&type=script&lang=ts"

import "./CognitoBrandedShell.vue?vue&type=style&index=0&id=497ccc92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497ccc92"]])

export default __exports__